import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from '../../services/apiUrls';

import { toastError, toastSuccess } from "../../utils/react-toaster";
import { deleteBrandData, getAllBrandsData, saveAllBrandData, saveBrandData } from "../slices";

export interface ResponseGenerator {
  config?: any,
  data?: any,
  headers?: any,
  request?: any,
  status?: number,
  statusText?: string,
  success?: boolean
  code?: any;
  results?: any;
  productvo?: any;
}


function* fetchAllBrandsData(actions?: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.BRANDS.getAllBrandsApi
    })
    if (response) {
      yield put(saveAllBrandData(response));
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteBrand(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.BRANDS.deleteBrandApi(actions.payload.mid),
    })
    if (response.code) {
      toastError(response.code);
      actions.payload.callback && actions.payload.callback(false);
    } else {
      actions.payload.callback && actions.payload.callback(true);
    }
  } catch (error) {
    actions.payload.callback && actions.payload.callback(false);
    console.log(error);
  }
}

function* saveBrand(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.BRANDS.saveBrandApi,
      data: actions.payload.dataToPost
    })
    if (!response?.code) {
      actions.payload.callback(response);
    }
  } catch (error) {
    // actions.payload.callback(false);
    console.log(error);
  }
}



export default function* root() {
  yield takeEvery(saveBrandData.type, saveBrand);
  yield takeEvery(getAllBrandsData.type, fetchAllBrandsData);
  yield takeEvery(deleteBrandData.type, deleteBrand);
}

